import React from 'react';
import { cn } from '../../lib/utils';

export interface TailwindCardProps {
  id?: string;
  icon: string; // Material Symbols icon name
  title: string;
  description?: string;
  badge?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export default function TailwindCard({
  id,
  icon,
  title,
  description,
  badge,
  onClick,
  className,
  disabled = false,
}: TailwindCardProps) {
  const isClickable = !!onClick && !disabled;

  return (
    <div
      onClick={isClickable ? onClick : undefined}
      className={cn(
        'card-hover border border-slate-100 bg-white rounded-xl p-5 flex flex-col gap-4 group',
        isClickable && 'cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {/* Header: Icon + Badge */}
      <div className="flex items-start justify-between">
        <div className={cn(
          'size-10 rounded-lg bg-slate-50 text-slate-500 flex items-center justify-center transition-colors shadow-sm',
          isClickable && 'group-hover:bg-primary group-hover:text-white'
        )}>
          <span className="material-symbols-outlined text-[24px]">{icon}</span>
        </div>
        {badge && (
          <span className="text-[10px] font-bold text-slate-400">{badge}</span>
        )}
      </div>

      {/* Content */}
      <div>
        <h4 className={cn(
          'font-bold text-slate-900 transition-colors',
          isClickable && 'group-hover:text-primary'
        )}>
          {title}
        </h4>
        {description && (
          <p className="text-xs text-slate-500 mt-1 leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
